<script lang="ts" setup>
import type { Profile, Meeting } from '@/stores/appStore'
import { computed, type PropType, ref } from 'vue'

const profiles = defineModel('profiles', { required: true, type: Array as PropType<Profile[]> })
const meetings = defineModel('meetings', { required: true, type: Array as PropType<Meeting[]> })
const shortMeetingsCount = ref(0)
const mediumMeetingsCount = ref(0)
const longMeetingsCount = ref(0)

const profileCount = computed(() => {
  return profiles.value.length
})

const numberOfMeetings = computed(() => {
  const eventIDs = profiles.value.map((profile) => profile.eventID)
  return meetings.value.filter((meeting) => eventIDs.includes(meeting.eventID)).length
})

const meetingTime = computed(() => {
  const eventIDs = profiles.value.map((profile) => profile.eventID)
  const totalTime = meetings.value
    .filter((meeting) => eventIDs.includes(meeting.eventID))
    .reduce((acc, meeting) => {
      const meetingTime = new Date(meeting.end).getTime() - new Date(meeting.start).getTime()
      const oneMinute = 60000
      if (meetingTime < 30 * oneMinute) shortMeetingsCount.value++
      else if (meetingTime < 60 * oneMinute) mediumMeetingsCount.value++
      else longMeetingsCount.value++
      return acc + meetingTime
    }, 0)
  return totalTime / 60000 / 60
})
</script>
<template>
  <div class="row q-col-gutter-md full-width">
    <div class="col-12 col-sm-6 col-md paddingFixer">
      <div class="myCard q-pa-md">
        <div class="text-h6 text-primary"><q-icon name="mdi-calendar-check" /> Meetings</div>
        <span class="stat-value">{{ numberOfMeetings }}</span>
        <span class="text-caption text-grey-6"> So far</span>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-md paddingFixer">
      <div class="myCard q-pa-md">
        <div class="text-h6 text-primary"><q-icon name="mdi-clock-time-five" /> Time in Meetings</div>
        <span class="stat-value">{{ meetingTime.toFixed(2) }}</span>
        <span class="text-caption text-grey-6"> Hours</span>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-md paddingFixer">
      <div class="myCard q-pa-md">
        <div class="text-h6 text-primary"><q-icon name="mdi-timer-check-outline" /> Prep Time Saved</div>
        <span class="stat-value">
          {{ ((profileCount * 10) / 60).toFixed(2) }}
          <q-tooltip>{{ profileCount }} profiles * 10 minutes per profile</q-tooltip>
        </span>
        <span class="text-caption text-grey-6"> Hours</span>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-md paddingFixer">
      <div class="myCard q-pa-md">
        <div class="text-h6 text-primary"><q-icon name="mdi-account-check" /> Profiles Pulled</div>
        <span class="stat-value">{{ profileCount }}</span>
        <span class="text-caption text-grey-6"> People</span>
      </div>
    </div>

    <!-- <div class="col-12 col-md-8 myCard q-pa-md">
        <Doughnut :data="chartData" :options="options" />
      </div> -->
  </div>
</template>
